import { FC, useEffect, useState } from "react";
import SideBarHeader from "../common/SideBarHeader";
import {
  giftCardMidSizeSVG,
  grayTrash,
  miniMembershipSVG,
  smallClockSVG,
} from "../../../assets/SVGs/SVGs";
import GiftCard from "./Membership";
import { useSelector } from "react-redux";
import { Button, Form, Input } from "antd";
import { getWeekDay } from "../../../utils/DateUtils";
import { useNavigate } from "react-router-dom";
import Membership from "./Membership";
import { bookingMembership } from "../../../types/membership";

interface GiftCardsSideBarProps {}

const GiftCardsSideBar: FC<GiftCardsSideBarProps> = ({}) => {
  const { memberships, date, client } = useSelector(
    (state: {
      cart: {
        memberships: {
          memberships: bookingMembership[];
          date: Date | null;
        };
        client: {
          phoneNumber: string | null;
          token: string | null;
        };
      };
    }) => {
      return {
        memberships: state.cart.memberships.memberships,
        date: state.cart.memberships.date,
        client: state.cart.client,
      };
    }
  );
  const [coupon, setCoupon] = useState<string | null>(null);
  const [validCoupon, setValidCoupon] = useState<boolean | null>(null);
  const navigate = useNavigate();
  const url = window.location.href;

  const handleSubmit = () => {
    if (client?.token) {
      navigate("auth");
      return;
    }
    if (!url.includes("pick-date")) {
      navigate("pick-date");
      return;
    }
    if (!url.includes("checkout")) {
      navigate("checkout");
      return;
    }
  };
  return (
    <div className="space-y-4 min-h-[50vh]  ">
      <div className="flex flex-col  items-center bg-[#EEF0FF] p-4 rounded  space-y-4  w-full">
        <SideBarHeader title=" العضويات المحددة" icon={miniMembershipSVG} />
        <div className="bg-white rounded-lg p-4 w-full">
          <div className="flex flex-col justify-between gap-2 h-full">
            <div>
              {date ? (
                <div className="border-[1px] border-[#EEF0FF] border-solid  border-x-0 border-t-0 p-1">
                  <div className="flex gap-2 items-center justify-center p-2 bg-[#FBFBFF] rounded  ">
                    <span>{smallClockSVG}</span>
                    <span className="text-color-primary font-semibold">
                      {getWeekDay(new Date(date))} - {new Date(date).getDate()}{" "}
                      -{" "}
                      {new Date(date).toLocaleString("ar", {
                        month: "long",
                      })}
                    </span>
                  </div>
                </div>
              ) : null}
              <div className="max-h-[52vh] overflow-auto">
                {memberships.map((membership, i) => (
                  <Membership key={i} membership={membership} />
                ))}
              </div>
              {url.includes("checkout") ? (
                <div className="inp-no-border">
                  <Form layout="vertical" className="w-full ">
                    <Form.Item
                      name="coupon"
                      hasFeedback
                      rules={[
                        {
                          validator: (_, value) => {
                            if (value && value === "lookfindr") {
                              setValidCoupon(true);
                              return Promise.resolve();
                            }
                            if (validCoupon === true) {
                              return Promise.resolve();
                            } else {
                              return Promise.reject(
                                new Error("الكود غير صالح")
                              );
                            }
                          },
                        },
                      ]}
                    >
                      <Input
                        value={coupon || ""}
                        addonAfter={
                          <Button
                            htmlType="button"
                            type="link"
                            onClick={() => {
                              setCoupon(null);
                              setValidCoupon(null); //todo fix this by api logic
                            }}
                          >
                            {validCoupon ? grayTrash : "تفعيل"}
                          </Button>
                        }
                        placeholder="ادخل كود الخصم"
                        onChange={(e) => setCoupon(e.target.value)}
                      />
                    </Form.Item>
                  </Form>
                </div>
              ) : null}
            </div>
            <div className="space-y-2">
              {url.includes("checkout") ? (
                // validCoupon ? (
                true ? (
                  <div>
                    <p className="flex justify-between">
                      <span className="text-color-sec-title">
                        الضريبه المضافة %
                      </span>
                      <span className="text-color-primary">
                        8 <small className="text-color-sec-title">ريال</small>
                      </span>
                    </p>
                    <p className="flex justify-between">
                      <span className="text-[#479821]"> كود 8% -</span>
                      <span className="text-color-primary">
                        9 <small className="text-color-sec-title">ريال</small>
                      </span>
                    </p>
                  </div>
                ) : null
              ) : null}
              <div className="flex w-full justify-between gap-1 self-end">
                <p className="text-color-primary">الحساب الكلي</p>
                <p>
                  <span className="text-color-primary">
                    {memberships.reduce((a, b) => a + +b.price, 0)}
                  </span>
                  <small className="text-color-sec-title">ريال</small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {true ? (
        <div>
          <Button
            block
            size="large"
            type="primary"
            htmlType="submit"
            onClick={handleSubmit}
          >
            شراء الآن{" "}
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default GiftCardsSideBar;
